import React from 'react';
import { useQuery } from '@apollo/client';
import { ERROR_MESSAGE } from '../Messages/Messages';
import TmntHtml from '../Common/Text/TmntHtml';
import {
  UPPER_FUNNEL_CONTENT_MOBILE_QUERY,
} from './operations';

function UpperFunnelLoginMobileContent() {
  const {
    loading,
    error,
    data,
  } = useQuery(UPPER_FUNNEL_CONTENT_MOBILE_QUERY);

  if (loading) return null;
  if (error) return ERROR_MESSAGE;

  const { textFor } = data;

  return (
    <TmntHtml tmnt={textFor?.upperFunnelToasterContentMobile} />
  );
}

export default UpperFunnelLoginMobileContent;
